export default __webpack_public_path__ + "static/media/linkinsert_link.ae948bba.svg";